// EP-133 T133-019 — visitor widget admin config types.
//
// Shape mirrors api/db/migrate/20260821090000_create_visitor_widgets.rb and
// VisitorWidgetPolicy (§8 Q-1 REFINED, GBP-style weekly availability): per
// weekday, 0..n [open, close] windows, e.g. {"mon": [["09:00","12:00"],
// ["13:00","17:00"]], "sun": []}. A missing key and an empty array both mean
// "closed all day" — there is no separate "day off" flag.
export type Weekday = 'mon' | 'tue' | 'wed' | 'thu' | 'fri' | 'sat' | 'sun'

export const WEEKDAYS: Weekday[] = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun']

/** [open, close], both "HH:MM" 24h strings. */
export type AvailabilityWindow = [string, string]

export type WeeklyAvailability = Partial<Record<Weekday, AvailabilityWindow[]>>

export interface VisitorWidget {
  id: number
  property_id: number
  /** Null until staff issues the first key via rotate_public_key — no public
   *  booking surface exists yet (mirrors ParkingZone#public_check_in_key). */
  public_key: string | null
  enabled: boolean
  slot_minutes: number
  availability: WeeklyAvailability
  lead_time_minutes: number
  max_per_slot: number
  booking_window_days: number
  created_at: string
  updated_at: string
}
